module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-ICON-blue-background.e9fae7ce.png";